import dictMKB10 from './mkb10/apiDictMKB10.js'

export default {
  ...dictMKB10,
}
